import { __rest } from "tslib";
import React, { useMemo } from 'react';
import isEqualWith from 'lodash/isEqualWith';
import { useSelector, useDispatch } from 'react-redux';
import { DuperbrowseStreamContext, } from './DuperbrowseStreamContext';
import { getLastViewedItem } from '../redux/selectors';
import { loadDuperbrowse } from '../redux/actionCreators';
import { useDeepEqualCustomMemo } from '../../utils/hooks/useDeepEqualMemo';
import { makeDeviationId } from '../../redux/normalizr/schemas/deviation';
var DuperbrowseStreamContextProvider = function (_a) {
    var children = _a.children, stream = _a.stream;
    var lastViewedItem = useSelector(getLastViewedItem);
    var dispatch = useDispatch();
    var memodStream = useDeepEqualCustomMemo(stream, function (a, b) {
        var _a, _b, _c, _d, _e, _f;
        // use default comparison for loadable and normalized streams
        if (!((_c = (_b = (_a = a) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.hasOwnProperty('deviationId')) ||
            !((_f = (_e = (_d = b) === null || _d === void 0 ? void 0 : _d.items) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.hasOwnProperty('deviationId'))) {
            return undefined;
        }
        var _g = a, aItems = _g.items, aWithoutItems = __rest(_g, ["items"]);
        var _h = b, bItems = _h.items, bWithoutItems = __rest(_h, ["items"]);
        if (!isEqualWith(aWithoutItems, bWithoutItems)) {
            return false;
        }
        return isEqualWith(aItems, bItems, function (aItem, bItem) { return makeDeviationId(aItem) === makeDeviationId(bItem); });
    });
    var contextProps = useMemo(function () { return ({
        stream: memodStream,
        lastViewedItem: lastViewedItem,
        loadDuperbrowse: function (itemId, streamId) {
            return dispatch(loadDuperbrowse(itemId, streamId));
        },
    }); }, [dispatch, lastViewedItem, memodStream]);
    return (React.createElement(DuperbrowseStreamContext.Provider, { value: contextProps }, children));
};
DuperbrowseStreamContextProvider.displayName =
    'DuperbrowseStreamContextProvider';
export default DuperbrowseStreamContextProvider;
//# sourceMappingURL=DuperbrowseStreamContextProvider.js.map